//import { Subject } from 'rxjs/Subject';
import { Injectable } from '@angular/core';
import { AreaActivities } from '../models/areaActivities.model';
import { Jobs } from '../models/jobs.model';
import { Professions } from '../models/professions.model';
import { Trainings } from '../models/trainings.model';
import { Languages } from 'src/app/models/languages.model';
import { Skills } from '../models/skills.model';
import { HttpService } from './http.service';
import Swal from 'sweetalert2';
import { Companies } from '../models/companies.model';
import { Router } from '@angular/router';
import { Produits } from '../models/produits.model';
import { Expertises } from '../models/expertises.model';

@Injectable()
export class FunctionsService {

  constructor(private httpService: HttpService, private router: Router) { }

  getExpertiseList(): any {
    let expertiseList: Expertises[] = [];
    if (localStorage.getItem('expertises') != undefined) {
      const dataString: any = localStorage.getItem('expertises');
      let arrayData = JSON.parse(dataString);

      arrayData.forEach((element: any) => {
        let expertises = new Expertises(element);
        expertiseList.push(expertises);
      });
    }

    return expertiseList;
  }

  getExpertisesFromServer() {
    this.httpService.getExpertises().subscribe(
      (response: any) => {
        if (response.status == "success") {
          localStorage.setItem('expertises', JSON.stringify(response.data.list));
        }
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        });
      }
    );
  }

  getProduitsList(): any {
    let produitList: Produits[] = [];
    if (localStorage.getItem('produits') != undefined) {
      const dataString: any = localStorage.getItem('produits');
      let arrayData = JSON.parse(dataString);

      arrayData.forEach((element: any) => {
        let produits = new Produits(element);
        produitList.push(produits);
      });
    }

    return produitList;
  }

  getProduitsFromServer() {
    this.httpService.getProduits().subscribe(
      (response: any) => {
        if (response.status == "success") {
          localStorage.setItem('produits', JSON.stringify(response.data.list));
        }
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        });
      }
    );
  }

  checkAdminIsConnected() {
    const data: any = localStorage.getItem('currentAdmin');
    const currentAdmin = JSON.parse(data);
    if (currentAdmin == null || currentAdmin == undefined) {
      //this.router.navigate(['/admin/connexion']);
      return null;
    }

    return currentAdmin;
  }

  wordWrap(word: string, limit: number) {
    let newWord = "";
    for (let index = 0; index < word.length; index++) {
      if (index < limit) {
        const char = word[index];

        newWord += char;
      } else {
        break;
      }
    }

    return (word.length > newWord.length) ? newWord + '...' : newWord;
  }

  getCompaniesFromServer() {
    this.httpService.getCompanies().subscribe(
      (response: any) => {
        if (response.status == "success") {
          localStorage.setItem('companies', JSON.stringify(response.data.list));
        }
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        });
      }
    );
  }

  getSkillsFromServer() {
    this.httpService.getSkills().subscribe(
      (response: any) => {
        if (response.status == "success") {
          localStorage.setItem('skills', JSON.stringify(response.data.list));
        }
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        });
      }
    );
  }

  getLanguagesFromServer() {
    this.httpService.getLanguages().subscribe(
      (response: any) => {
        if (response.status == "success") {
          localStorage.setItem('languages', JSON.stringify(response.data.list));
        }
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        });
      }
    );
  }

  getAreaActivitiesFromServer() {
    this.httpService.getAreaActivities().subscribe(
      (response: any) => {
        if (response.status == "success") {
          localStorage.setItem('areaActivities', JSON.stringify(response.data.list));
        }
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        });
      }
    );
  }

  getTrainingsFromServer() {
    this.httpService.getTrainings().subscribe(
      (response: any) => {
        if (response.status == "success") {
          localStorage.setItem('trainings', JSON.stringify(response.data.list));
        }
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        });
      }
    );
  }

  getProfessionsFromServer() {
    this.httpService.getProfessions().subscribe(
      (response: any) => {
        if (response.status == "success") {
          localStorage.setItem('professions', JSON.stringify(response.data.list));
        }
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        });
      }
    );
  }

  getCompaniesList(): any {
    let companyList: Companies[] = [];
    if (localStorage.getItem('companies') != undefined) {
      const dataString: any = localStorage.getItem('companies');
      let arrayData = JSON.parse(dataString);

      arrayData.forEach((element: any) => {
        let companies = new Companies(element);
        companyList.push(companies);
      });
    }

    return companyList;
  }

  getSkillsList(): any {
    let skillList: Skills[] = [];
    if (localStorage.getItem('skills') != undefined) {
      const dataString: any = localStorage.getItem('skills');
      let arrayData = JSON.parse(dataString);

      arrayData.forEach((element: any) => {
        let skills = new Skills(element);
        skillList.push(skills);
      });
    }

    return skillList;
  }

  getLanguagesList(): any {
    let languageList: Languages[] = [];
    if (localStorage.getItem('languages') != undefined) {
      const dataString: any = localStorage.getItem('languages');
      let arrayData = JSON.parse(dataString);

      arrayData.forEach((element: any) => {
        let languages = new Languages(element);
        languageList.push(languages);
      });
    }

    return languageList;
  }

  getAreaActivitiesList(): any {
    let list: AreaActivities[] = [];
    if (localStorage.getItem('areaActivities') != undefined) {
      const dataString: any = localStorage.getItem('areaActivities');
      let arrayData = JSON.parse(dataString);

      arrayData.forEach((element: any) => {
        let areaActivities = new AreaActivities(element);
        list.push(areaActivities);
      });
    }

    return list;
  }

  getTrainingsList(): any {
    let trainingList: Trainings[] = [];
    if (localStorage.getItem('trainings') != undefined) {
      const dataString: any = localStorage.getItem('trainings');
      let arrayData = JSON.parse(dataString);

      arrayData.forEach((element: any) => {
        let training = new Trainings(element);
        trainingList.push(training);
      });
    }

    return trainingList;
  }

  getProfessionsList(): any {
    let list: Professions[] = [];
    if (localStorage.getItem('professions') != undefined) {
      const dataString: any = localStorage.getItem('professions');
      let arrayData = JSON.parse(dataString);

      arrayData.forEach((element: any) => {
        let professions = new Professions(element);
        list.push(professions);
      });
    }

    return list;
  }

  findCitiesOfCountry(countryName: string, countryList: any[]) {
    let citiesOfCountry: any[] = [];
    countryList.find((item: { country: string; name: any; }) => {
      if (item.country === countryName) {
        const cityName = item.name
        citiesOfCountry.push(cityName)
      }
    });

    return citiesOfCountry.sort()
  }

  showOrHideSearchBlockField(blockId: string, labelBlockId: string) {
    let mainBlock: any = document.getElementById(blockId);
    let labelBlockToShowOrHide: any = document.getElementById(labelBlockId);

    if (window.getComputedStyle(mainBlock).display === "none") {
      mainBlock.style.display = "flex";
      labelBlockToShowOrHide.innerHTML = "Afficher moins";
    } else {
      mainBlock.style.display = "none";
      labelBlockToShowOrHide.innerHTML = "Afficher plus";
    }
  }

  showOrHideBlock(blockId: string, labelBlockId: string) {
    let mainBlock: any = document.getElementById(blockId);
    let labelBlockToShowOrHide: any = document.getElementById(labelBlockId);

    if (window.getComputedStyle(mainBlock).display === "none") {
      mainBlock.style.display = "block";
      labelBlockToShowOrHide.innerHTML = "Afficher moins";
    } else {
      mainBlock.style.display = "none";
      labelBlockToShowOrHide.innerHTML = "Afficher plus";
    }
  }

  showOrHideBlockregister(blockId: string, labelBlockId: string) {
    let mainBlock: any = document.getElementById(blockId);
    let labelBlockToShowOrHide: any = document.getElementById(labelBlockId);
    if (window.getComputedStyle(mainBlock).display === "none") {
      mainBlock.style.display = "block";
      labelBlockToShowOrHide.style.display = "none";
    }
  }
  HideBlock(blockId: string, labelBlockId: string) {
    let mainBlock: any = document.getElementById(blockId);
    let labelBlockToShowOrHide: any = document.getElementById(labelBlockId);
    mainBlock.style.display = "none";
    labelBlockToShowOrHide.style.display = "block";
  }

  showOrHideEndDate(blockIdTohide: string, checkboxIdClicked: string, inputClicked: boolean) {
    let mainBlock: any = document.getElementById(blockIdTohide);
    let checkbox: any = document.getElementById(checkboxIdClicked);

    if (inputClicked) {
      if (checkbox.checked) {
        mainBlock.style.display = "none";
      } else {
        mainBlock.style.display = "block";
      }
    } else {
      if (!checkbox.checked) {
        mainBlock.style.display = "none";
      } else {
        mainBlock.style.display = "block";
      }
    }
  }

  searchJob(jobID: number, list: any[]) {
    for (let index = 0; index < list.length; index++) {
      const element = list[index];
      let job = new Jobs(element);
      if (job.getId() == jobID) {
        return job;
      }
    }
    return undefined;
  }
}